export default __webpack_public_path__ + "static/media/Fala elektromagnetyczna.aad08320.png";